const $ = jQuery.noConflict();
/* eslint-disable */
'use strict';
const BookingsMyAcc = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.tabs();
		this.filters();
		this.singleView();
		this.cancelOrder();
		$('#type').val(null).trigger('change.select2');
		$('#range').val(null).trigger('change.select2');
		this.noOrdersMsg();
		$('.js-bookings-tab').first().addClass('active-link');
		$('.js-bookings-tab').on('click', function() {
			$(this).addClass('active-link').siblings().removeClass('active-link');
		});
		this.activateChat();
	},
	activateChat() {
		function onTidioChatApiReady() {
			window.tidioChatApi.hide();
		}

		if (window.tidioChatApi) {
			window.tidioChatApi.on('ready', onTidioChatApiReady);
		}

		if (document.querySelector('.js-click-chat')) {
			document.querySelector('.js-click-chat').addEventListener('click', function() {
				window.tidioChatApi.show();
				window.tidioChatApi.open();
			});
		}

	},
	noOrdersMsg() {
		if ($('.js-bookings-table-upcoming .js-myaccount-table__body-wrap').length < 1) {
			$('.js-bookings-table-upcoming .js-no-booking-message').show();
		}
		if ($('.js-bookings-table-past .js-myaccount-table__body-wrap').length < 1) {
			$('.js-bookings-table-past .js-no-booking-message').show();
		}
	},
	tabs() {
		const tabs = document.querySelectorAll('.js-bookings-tab');
		if (!tabs) {
			return;
		}

		const switchTabs = function() {
			const tables = document.querySelectorAll('.js-bookings-table');
			for (let i = 0; i < tables.length; i++) {
				tables[i].classList.remove('active');
			}
			const dataId = this.getAttribute('data-id');
			const wrap = document.querySelector(`.js-bookings-table[data-id="${dataId}"]`);
			wrap.classList.add('active');
			$('select#type').val('clear').trigger('change');
			$('select#range').val('clear').trigger('change');
			$('select#date').val('newest').trigger('change');
			$('.js-myaccount-table__body-wrap').removeClass('hide');
			if ($('.js-bookings-table.active .js-myaccount-table__body-wrap').length < 1) {
				$('.js-no-booking-message').show();
			} else {
				$('.js-no-booking-message').hide();
			}
		};

		for (let i = 0; i < tabs.length; i++) {
			tabs[i].addEventListener('click', switchTabs);
		}
	},
	filters() {
		const filters = $('.js-booking-filter');
		if (!filters) {
			return;
		}

		const obj = {
			type: '',
			range: '',
			date: '',
		};

		const filtering = function() {
			const allRows = $('.js-myaccount-table__body-wrap');
			const bookingTable = $('.js-bookings-table');
			allRows.addClass('hide');
			obj.type = $('#type').val();
			obj.range = $('#range').val();
			obj.date = $('#date').val();
			const tableRowsArr = document.querySelectorAll('.js-myaccount-table__body-wrap');
			for (let i = 0; i < tableRowsArr.length; i++) {
				const isInWeek = tableRowsArr[i].getAttribute('data-this-week'); // 19
				const isInMonth = tableRowsArr[i].getAttribute('data-this-month'); // 11
				const isInYear = tableRowsArr[i].getAttribute('data-this-year'); // 2021
				// const type = tableRowsArr[i].getAttribute('data-recurring'); // one-time/recurring

				if (obj.type === 'all' && (obj.range === '' || obj.range === null)) {
					if (isInWeek === '' && isInMonth === '' && isInYear === '') {
						$('.js-myaccount-table__body-wrap').removeClass('hide');
					}
				}

				if (obj.type === 'all' && obj.range === 'week') {
					if (isInWeek === '1') {
						$('.js-myaccount-table__body-wrap[data-this-week="1"]').removeClass('hide');
					}
				}

				if (obj.type === 'all' && obj.range === 'month') {
					if (isInMonth === '1') {
						$('.js-myaccount-table__body-wrap[data-this-month="1"]').removeClass('hide');
					}
				}


				if (obj.type === 'all' && obj.range === 'year') {
					if (isInYear === '1') {
						$('.js-myaccount-table__body-wrap[data-this-year="1"]').removeClass('hide');
					}
				}

				if (obj.type === 'one-time' && (obj.range === '' || obj.range === null)) {
					$('.js-myaccount-table__body-wrap[data-recurring="one-time"]').removeClass('hide');
				}

				if (obj.type === 'one-time' && obj.range === 'week') {
					if (isInWeek === '1') {
						$('.js-myaccount-table__body-wrap[data-this-week="1"][data-recurring="one-time"]').removeClass('hide');
					}
				}
				if (obj.type === 'one-time' && obj.range === 'month') {
					if (isInMonth === '1') {
						$('.js-myaccount-table__body-wrap[data-this-month="1"][data-recurring="one-time"]').removeClass('hide');
					}
				}
				if (obj.type === 'one-time' && obj.range === 'year') {
					if (isInYear === '1') {
						$('.js-myaccount-table__body-wrap[data-this-year="1"][data-recurring="one-time"]').removeClass('hide');
					}
				}

				if (obj.type === 'recurring' && (obj.range === '' || obj.range === null)) {
					$('.js-myaccount-table__body-wrap[data-recurring="recurring"]').removeClass('hide');
				}
				if (obj.type === 'recurring' && obj.range === 'week') {
					if (isInWeek === '1') {
						$('.js-myaccount-table__body-wrap[data-this-week="1"][data-recurring="recurring"]').removeClass('hide');
					}
				}
				if (obj.type === 'recurring' && obj.range === 'month') {
					if (isInMonth === '1') {
						$('.js-myaccount-table__body-wrap[data-this-month="1"][data-recurring="recurring"]').removeClass('hide');
					}
				}
				if (obj.type === 'recurring' && obj.range === 'year') {
					if (isInYear === '1') {
						$('.js-myaccount-table__body-wrap[data-this-year="1"][data-recurring="recurring"]').removeClass('hide');
					}
				}
			}
			const countActive = $('.js-myaccount-table__body-wrap:visible');
			if (countActive.length < 1) {
				$('.js-no-booking-message').show();
			} else {
				$('.js-no-booking-message').hide();
			}
		};
		filters.on('change', filtering);

		// sorting
		$('.js-booking-filter-date').on('change', function() {
			if ($(this).val() === 'newest') {
				$('.js-bookings-table').css('flex-direction', 'column');
			} else {
				$('.js-bookings-table').css('flex-direction', 'column-reverse');
			}
		});


	},
	singleView() {
		const viewButtons = document.querySelectorAll('.js-view-booking');
		if (!viewButtons) {
			return;
		}

		const triggerSingleView = function() {
			const popup = document.querySelector('.js-svb');
			const myaccountHeader = document.querySelector('.js-myaccount-header');
			const myaccountBooking = document.querySelector('.myaccount-booking');
			const data = {
				action: 'get_single_booking_view',
				orderId: this.getAttribute('data-id')
			};
			BookingsMyAcc.ajaxFunc(data);
			popup.classList.add('active');
			myaccountHeader.classList.add('hide-part');
			myaccountBooking.classList.add('hide-part');
		};

		for (let i = 0; i < viewButtons.length; i++) {
			viewButtons[i].addEventListener('click', triggerSingleView);
		}
	},
	cancelOrder() {
		const btn = document.querySelector('.js-cancel-order-sbv');
		if (!btn) {
			return;
		}
		btn.addEventListener('click', function() {
			const orderId = this.getAttribute('data-id');
			const loader = document.querySelector('.js-svb-cancel-loader');
			loader.classList.add('active-loader');
			this.style.pointerEvents = 'none';
			const data = {
				action: 'cancel_order',
				orderId: orderId
			};
			BookingsMyAcc.ajaxFunc(data);
		});
	},
	closeSingleView() {
		const close = document.querySelector('.js-svb-close');
		if (!close) {
			return;
		}
		const popup = document.querySelector('.js-svb');
		const myaccountHeader = document.querySelector('.js-myaccount-header');
		const myaccountBooking = document.querySelector('.myaccount-booking');
		close.addEventListener('click', function() {
			popup.classList.remove('active');
			popup.innerHTML = '';
			myaccountBooking.classList.remove('hide-part');
			myaccountHeader.classList.remove('hide-part');
		});
	},
	// ajax function
	ajaxFunc: function(data) {
		$.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			data: data,
			success: (response) => {
				if (response.data.action === 'singleView') {
					const singleView = document.querySelector('.js-svb');
					singleView.innerHTML = response.data.data;
					singleView.classList.add('active');
					BookingsMyAcc.closeSingleView();
				}
				if (response.data.action === 'cancelOrder') {
					const canceledOrder = $(`.js-myaccount-table__body-wrap[data-order="${response.data.data}"]`);
					const pastTable = $('.js-bookings-table-past');
					canceledOrder.appendTo(pastTable);
					$('.js-booking-cancel__popup .booking-cancel__popup-ico').trigger('click');
					const loader = document.querySelector('.js-svb-cancel-loader');
					loader.classList.remove('active-loader');
					const btn = document.querySelector('.js-cancel-order-sbv');
					btn.style.pointerEvents = 'auto';
					const close = document.querySelector('.js-svb-close');
					if (close) {
						close.click();
					}
					BookingsMyAcc.noOrdersMsg();
				}
				BookingsMyAcc.activateChat();
			}
		});
	},
	filterWeek(year, month, day) {
		// if is in array (use === if is not in array)
		return BookingsMyAcc.thisWeek().indexOf(year + '-' + month + '-' + day) !== -1;
	},
	filterMonth(currentMonth, month) {
		return currentMonth === parseInt(month);
	},
	filterYear(currentYear, year) {
		return currentYear === parseInt(year);
	},
	isEmptyObject(obj) {
		return JSON.stringify(obj) === '{}';
	},
	thisWeek() {
		const curr = new Date();
		const week = [];

		for (let i = 1; i <= 7; i++) {
			const first = curr.getDate() - curr.getDay() + i - 1;
			const day = new Date(curr.setDate(first)).toISOString().slice(0, 10);
			week.push(day);
		}
		return week;
	}
};

export default BookingsMyAcc;
